import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { IonicRatingModule } from 'ionic-rating';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ActivityIndexComponent } from 'src/app/components/activity-index/activity-index.component';
import { DeleteAccountComponent } from 'src/app/components/delete-account/delete-account.component';
import { ImgCropperComponent } from 'src/app/components/image-cropper/image-cropper.component';
import { CountrySearchComponent } from 'src/app/components/profile/country-search/country-search.component';
import { HandballPlayerPositionComponent } from 'src/app/components/profile/player-profile/handball-player-position/handball-player-position.component';
import { PlayerPositionComponent } from 'src/app/components/profile/player-profile/player-position/player-position.component';
import { PlayerProfileComponent } from 'src/app/components/profile/player-profile/player-profile.component';
import { ScoutProfileComponent } from 'src/app/components/profile/scout-profile/scout-profile.component';
import { TopSkillsComponent } from 'src/app/components/profile/top-skills/top-skills.component';
import { TrainerProfileComponent } from 'src/app/components/profile/trainer-profile/trainer-profile.component';
import { StateSelectComponent } from 'src/app/components/state-select/state-select.component';
import { TipsTricksFeedbackPopoverComponent } from 'src/app/components/tips-tricks-feedback-popover/tips-tricks-feedback-popover.component';
import { TrainingFeedbackPopoverComponent } from 'src/app/components/training-feedback-popover/training-feedback-popover.component';
import { VideoComponent } from 'src/app/components/video/video.component';
import { WallOfTextComponent } from 'src/app/components/wall-of-text/wall-of-text.component';

@NgModule({
  imports: [
    IonicModule,
    TranslateModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
    IonicRatingModule,
  ],
  declarations: [
    PlayerProfileComponent,
    PlayerPositionComponent,
    HandballPlayerPositionComponent,
    CountrySearchComponent,
    TopSkillsComponent,
    TrainerProfileComponent,
    ScoutProfileComponent,
    TipsTricksFeedbackPopoverComponent,
    TrainingFeedbackPopoverComponent,
    WallOfTextComponent,
    VideoComponent,
    ImgCropperComponent,
    StateSelectComponent,
    ActivityIndexComponent,
    DeleteAccountComponent,
  ],
  exports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    ImgCropperComponent,
    ImageCropperModule,
    PlayerProfileComponent,
    PlayerPositionComponent,
    TopSkillsComponent,
    TrainerProfileComponent,
    ScoutProfileComponent,
    WallOfTextComponent,
    VideoComponent,
    ActivityIndexComponent,
  ],
})
export class SharedModule {}
